import React from 'react';
import { Icon } from '../../../utilities/icomoon-css/index';
import { AccountPanelTypes } from '../AccountPanelTypes';
import {
  LargeIconSize,
  MediumIconSize,
} from '../constants/accountPanelConfigs';
import { Button } from '@codeparva/ui-components-library';

export const UserDetailsSection = ({
  name,
  email_address,
  siteType,
  currentLocation,
}: AccountPanelTypes.TUserDetailsSection) => (
  <div className="userInfoSection">
    <Icon
      name="tfw-profile-circle-cp"
      size={LargeIconSize}
      title="tfw-profile-circle-cp"
    />
    <span className="nameSection subtitle1">
      {name.first_name || ''} {name.last_name || ''}
    </span>
    <span className="emailAddressSection content1">
      {email_address.email_address || ''}
    </span>
    {siteType === 'multi' ? (
      <div className="locationSection">
        <Icon name="tfw-facility-cp" size={16} title="tfw-facility-cp" />
        <span className="locationNameMulti">
          {currentLocation?.location_name}
        </span>
      </div>
    ) : (
      <></>
    )}
  </div>
);

export const UserDetailsDropDown = ({
  name,
  showUserInfoSection,
}: AccountPanelTypes.TUserDetailsDropDown) => (
  <div className="nameSection">
    <Icon
      name={'tfw-profile-circle-cp'}
      size={MediumIconSize}
      title={'tfw-profile-circle-cp'}
    />
    <p>
      {name.first_name || ''} {name.last_name || ''}
    </p>
    <div className="downIconSection">
      <Icon
        name={
          showUserInfoSection
            ? 'tfw-arrow-down-bold-2-cp'
            : 'tfw-arrow-up-bold-2-cp'
        }
        size={MediumIconSize}
        title={'arrow-down-1'}
      />
    </div>
  </div>
);

export const LocationSection = ({ locationName }: { locationName: string }) => (
  <div className="locationNameSection">
    <Icon name={'tfw-geo-5-cp'} size={MediumIconSize} title={'tfw-geo-5-cp'} />
    <p className="pl-4 subtitle1">{locationName}</p>
  </div>
);

export const LogOutSection = ({
  logOutHandler,
}: AccountPanelTypes.TLedgerSectionLogOutHandler) => (
  <div className="logOutSection" onClick={logOutHandler}>
    <div className="labelSection">
      <Icon name={'tfw-logout-cp'} size={24} title={'tfw-logout-cp'} />
      <p className="subtitle2">Log Out</p>
    </div>
  </div>
);

export const LedgerSwitchControlSection = ({
  stateHandler,
  state,
}: AccountPanelTypes.TLedgerSwitchControlSection) => (
  <div
    className={`switchAccountSection ${state ? 'in-active-bg' : ''}`}
    onClick={() => stateHandler((prevValue: boolean) => !prevValue)}
  >
    <div className="labelSection">
      <Icon name={'tfw-arrow-2-cp'} size={24} title={'Arrow-Swap-Horizontal'} />
      <p className="subtitle2">Switch Account</p>
    </div>
    <Icon
      name={state ? 'tfw-arrow-up-bold-2-cp' : 'tfw-arrow-down-bold-2-cp'}
      size={24}
      title={'arrow-down-1'}
    />
  </div>
);

export const isActiveLink = (value: string, currLedgerId: string | undefined) =>
  currLedgerId === value ? 'active' : '';

export const ExitModal = ({
  bodyHeight,
  hideModal,
  logOutHandler,
}: AccountPanelTypes.TLogOutModal) => {
  return (
    <div
      className={`modal exitModalSection`}
      style={{
        marginTop: bodyHeight,
      }}
    >
      <div className="modal-background" />
      <div className="modal-card exitModalCard">
        <p className="subtitle1">Are you sure you want to logout?</p>
        <div className="buttonContainer">
          <Button onClick={() => logOutHandler()}>Yes</Button>
          <Button className="exitNoButton" onClick={() => hideModal()}>
            No
          </Button>
        </div>
      </div>
    </div>
  );
};
